export default __webpack_public_path__ + "static/media/Inter.b4c30855.ttf";